import { applyMiddleware, createStore } from 'redux';
import { syncHistoryWithStore} from 'react-router-redux';
import { browserHistory } from 'react-router';
import logger from "redux-logger";
import thunk from "redux-thunk";
import moment from 'moment';
import momentJalaali from 'moment-jalaali';

// import the root reducer
import rootReducer from './reducers/index';

moment.updateLocale('en', {
    week : {
        dow : 6 // Saturday is the first day of the week
    }
});

const activeLogger = false;

const defaultState = {
    timer : {
        'manual' : false,
        'active_record' : {
        'project' : {'name':'', color:''},
        'name' : ''},
        'manual_record' : {
        'project' : {'name':'', color:''},
        'name' : ''},
        'records' : {
            list : [],
            meta : {}
        },
        currentWeek : [],
        records_total_duration: 0,
        timer_loading : false,
        getWsRecords_running : false
    },
    app : {
        'loading' : 0,
        'login_status' : 0,
        'phone_number' : '',
        'main_loading' : true,
        'work_space' : {
            projects : []
        },
        'work_space_list': [],
        'display_duration': 7,
        'start_date' : momentJalaali({hour : 0, minute : 0, second: 0}).startOf('jMonth').locale('en').format('YYYY-MM-DDTHH:mm:ss'),
        'end_date' : momentJalaali({hour : 23, minute : 59, second: 59}).endOf('jMonth').locale('en').format('YYYY-MM-DDTHH:mm:ss'),
        'socket_connect' : false
    },
    project: {
        'data': [],
        'usersList': [],
        'objNumber': -1,
        'openModal': false,
        'colorPicker' : false,
        'readOnly': true,
        'paginationConfig': {
            'meta': {'pages':1,'page':1},
            'ur': '',
            'query': {},
            'updateAction': () => {},
            'perPage': 100
        }
    },
    report: {
        'export_file': "",
        'page_records': [],
        'all_records': [],
        'total_sum': 0,
        'barchartList': [],
        'groupBy': [{en:'project',fa:'پروژه'},{en:'name',fa:'عنوان'}], //project or user
        'groupedReport': [],
        'loadingGroupedReport': false,
        'days': {},
        'reportType': '0',
        'project_filters_number': 0,
        'user_filters_number': 0, 
        'paginationConfig': {
            'meta': {'per_page':1,'page':1},
            'url': 'record?',
            'query': {
                'start': momentJalaali({hour : 0, minute : 0, second: 0}).startOf('jMonth').locale('en').format('YYYY-MM-DDTHH:mm:ss'),
                'end': momentJalaali({hour : 23, minute : 59, second: 59}).endOf('jMonth').locale('en').format('YYYY-MM-DDTHH:mm:ss'),
                'workspace': '8eb84499-311a-476e-ab6b-8beb3ccdabc2',
                'project': [], 
                'user': [], 
                'suborder_by': 'duration'
            },
            'updateAction': () => {},
            'perPage': 100
        }
    },
    user: {
        name: '',
        phone_number: '',
        email: ''
    }
};

let middleware = {}
if( activeLogger && process.env.NODE_ENV !== 'production' ){
    middleware = applyMiddleware(thunk, logger)
}else{
    middleware = applyMiddleware(thunk)
}
const store = createStore(rootReducer, defaultState, middleware);

export const history = syncHistoryWithStore(browserHistory, store);

export default store;